import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from '../../../config/appConfig';
import Utils from '../../../utils/Utils';
import settings from "../../../devices/all/settings";

class LoginCMByEmailTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.body = {email: params.email, password: params.password}
    }

    getHeaders() {
        const headerParams = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return headerParams;
    }

    getUrl() {
        const config = getAppConfig();
        let url = `${config.end_point_music}/middleware/user/loginByEmail?`;
            url += this.getQueryStringParams();

        // url ya contiene el http/https
        return url;
    }

    getParams() {
        return Utils.encodeParams(this.body);
    }

    isValid(data) {
        if (!data.response) {
            return false;
        }
        return true;
    }

    getQueryStringParams() {
        let params = super.getParams();
        delete params.user_token;
        params.tenant_code = settings.tenant_code;
        params.version = '1.0.0';
        params = Object.assign({}, params, this.queryParams);
        return Utils.buildQueryParams(params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getMethod() {
        return 'POST';
    }

    getEncType() {
        return "application/x-www-form-urlencoded";
    }

    getShowErrorModal(){
      return false;
    }
}

export default LoginCMByEmailTask;






// WEBPACK FOOTER //
// ./src/requests/tasks/music/LoginCMByEmailTask.js